import { SnackBarVariants } from '@app/app.enum';
import CustomSnackBar from '@app/components/shared/snackbar.component';
import React, { useState } from 'react';

const withSnackBar = (
	WrappedComponent: React.ComponentType | React.FunctionComponent | React.ForwardRefExoticComponent<any>
) => {
	return React.forwardRef((props: any, ref: React.MutableRefObject<any>) => {
		const [open, setOpen] = useState<boolean>(false);
		const [messages, setMessages] = useState<string | string[]>('');
		const [variant, setVariant] = useState<SnackBarVariants>(SnackBarVariants.Success);

		// Close Snackbar
		const closeSnackBar = () => {
			setOpen(false);
			setMessages('');
		};

		// Open snackbar
		const openSnackbar = (message: string | string[], snackBarVariant: SnackBarVariants = SnackBarVariants.Success) => {
			setOpen(true);
			setMessages(message);
			setVariant(snackBarVariant);
		};

		return (
			<>
				<CustomSnackBar
					open={open}
					snackBarMessage={messages}
					autoHideDuration={2000}
					variant={variant}
					onClose={closeSnackBar}
					onIconClick={closeSnackBar}
				/>
				<WrappedComponent {...props} ref={ref} openSnackBar={openSnackbar} />
			</>
		);
	});
};

export default withSnackBar;



// WEBPACK FOOTER //
// ./src/components/core/message.component.tsx